import React from 'react';
import bottomImage1 from '../assets/bottomThree/1.svg';

const GenerationsSection = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="py-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6 sm:mb-8">A Club for All Generations</h2>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 leading-relaxed max-w-2xl">
              Our goal is to create a modern tennis club that brings together kids, families, and professionals. 
              With structured training, community events, and tournaments, the club becomes more than courts — 
              it becomes a home for tennis.
            </p>
            
            {/* <div className="generation-stats">
              <div className="stat">
                <div className="stat-number">500+</div>
                <div className="stat-label">Active Members</div>
              </div>
              <div className="stat">
                <div className="stat-number">15</div>
                <div className="stat-label">Years Experience</div>
              </div>
              <div className="stat">
                <div className="stat-number">8</div>
                <div className="stat-label">Professional Coaches</div>
              </div>
            </div> */}
          </div>
          
          <div>
            <img 
              src={bottomImage1}
              alt="Family playing tennis together"
              className="w-full h-auto rounded-xl shadow-[0_10px_30px_rgba(0,0,0,0.1)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenerationsSection;
